/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as runtime from '../runtime';
import { GarageSpotAttributeDtoToJSON, GarageSpotAttributeDtoGenericApiResponseFromJSON, GarageSpotAttributeDtoSortedPagedListResponseGenericApiResponseFromJSON, GarageSpotAttributeUpdateDtoToJSON, Int32GenericApiResponseFromJSON, SuccessfullApiResponseFromJSON, } from '../models';
/**
 *
 */
export class GarageSpotAttributesApi extends runtime.BaseAPI {
    /**
     */
    apiGarageSpotAttributesAddPostRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/api/GarageSpotAttributes/Add`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: GarageSpotAttributeDtoToJSON(requestParameters.garageSpotAttributeDto),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => Int32GenericApiResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiGarageSpotAttributesAddPost(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiGarageSpotAttributesAddPostRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    apiGarageSpotAttributesDeleteIdDeleteRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling apiGarageSpotAttributesDeleteIdDelete.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/GarageSpotAttributes/Delete/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => SuccessfullApiResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiGarageSpotAttributesDeleteIdDelete(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiGarageSpotAttributesDeleteIdDeleteRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    apiGarageSpotAttributesGetAllGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.pageNumber !== undefined) {
                queryParameters['PageNumber'] = requestParameters.pageNumber;
            }
            if (requestParameters.pageSize !== undefined) {
                queryParameters['PageSize'] = requestParameters.pageSize;
            }
            if (requestParameters.sortPropertyName !== undefined) {
                queryParameters['SortPropertyName'] = requestParameters.sortPropertyName;
            }
            if (requestParameters.sortDirection !== undefined) {
                queryParameters['SortDirection'] = requestParameters.sortDirection;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/GarageSpotAttributes/GetAll`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => GarageSpotAttributeDtoSortedPagedListResponseGenericApiResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiGarageSpotAttributesGetAllGet(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiGarageSpotAttributesGetAllGetRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    apiGarageSpotAttributesGetIdGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling apiGarageSpotAttributesGetIdGet.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/GarageSpotAttributes/Get/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => GarageSpotAttributeDtoGenericApiResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiGarageSpotAttributesGetIdGet(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiGarageSpotAttributesGetIdGetRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    apiGarageSpotAttributesUpdatePutRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/api/GarageSpotAttributes/Update`,
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: GarageSpotAttributeUpdateDtoToJSON(requestParameters.garageSpotAttributeUpdateDto),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => SuccessfullApiResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiGarageSpotAttributesUpdatePut(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiGarageSpotAttributesUpdatePutRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
}
